import React from "react";

export default function categoryTransformer(category) {
  const arr = Object.keys(category);

  return arr;
}
